export default __webpack_public_path__ + "static/media/quiz-radio-fill.12d87c12.svg";